<div *ngIf="visible"
  class="fixed inset-0 z-[10000] flex items-center justify-center bg-slate-900/60 px-4 backdrop-blur-[2px] modal-backdrop">
  <div
    class="flex max-h-[92vh] w-[95vw] max-w-2xl min-h-[420px] flex-col overflow-hidden rounded-2xl bg-white shadow-2xl modal-panel"
    (click)="$event.stopPropagation()">
    <div class="relative flex flex-none items-center bg-blue-800 px-6 py-5">
      <div class="flex min-w-0 flex-1 items-center gap-3.5 pr-10">
        <span
          class="flex h-11 w-2 flex-none items-center justify-center rounded-xl bg-white/10 text-slate-200 ring-1 ring-white/20">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M4 4h16v16H4z" />
            <path d="M22 6l-10 7L2 6" />
          </svg>
        </span>

        <div class="min-w-0 flex-1">

          <h3 class="truncate text-[17px] font-bold leading-snug text-white">
            {{ etape === 'recapitulatif' && !resultatEnvoi ? "Vérifier avant l'envoi" : 'Envoyer un mail' }}
          </h3>

          <!-- <h3 class="truncate text-[17px] font-bold leading-snug text-white">
            Envoyer un mail
          </h3> -->
          <p class="mt-0.5 text-[12px] text-slate-300" *ngIf="!resultatEnvoi">
            À {{ nombreDestinataires }} apprenant{{ nombreDestinataires > 1 ? 's' : '' }}
          </p>
        </div>
      </div>

      <button type="button"
        class="absolute right-5 top-1/2 flex h-8 w-2 -translate-y-1/2 items-center justify-center rounded-lg bg-white/10 text-slate-300 transition hover:bg-white/10 hover:text-white disabled:cursor-not-allowed disabled:opacity-40"
        (click)="fermerModal()" [disabled]="envoiEnCours" aria-label="Fermer">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
          <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
        </svg>
      </button>
    </div>
    <div *ngIf="!resultatEnvoi && etape === 'edition'"
      class="min-w-0 flex-1 overflow-y-auto overflow-x-hidden px-6 py-5">
      <div class="space-y-4">
        <div>
          <label class="mb-1 block text-[12.5px] font-semibold text-slate-700">
            Objet du mail
          </label>
          <input type="text" [(ngModel)]="objet" placeholder="Ex : Rappel de connexion à votre espace Moodle"
            class="w-full rounded-lg border px-3 py-2 text-[13px] text-slate-800 placeholder:text-slate-400 focus:outline-none"
            [ngClass]="
              formulaireSoumis && !objet.trim()
                ? 'border-red-300 focus:border-red-400'
                : 'border-slate-200 focus:border-slate-400'
            " />
          <p *ngIf="formulaireSoumis && !objet.trim()" class="mt-1 text-[11.5px] text-red-600">
            L'objet est obligatoire.
          </p>
        </div>

        <div>
          <label class="mb-1 block text-[12.5px] font-semibold text-slate-700">
            Contenu du mail
          </label>
          <textarea [(ngModel)]="contenu" rows="6" placeholder="Rédigez le message à envoyer…"
            class="w-full resize-none rounded-lg border px-3 py-2 text-[13px] text-slate-800 placeholder:text-slate-400 focus:outline-none"
            [ngClass]="
              formulaireSoumis && !contenu.trim()
                ? 'border-red-300 focus:border-red-400'
                : 'border-slate-200 focus:border-slate-400'
            "></textarea>
          <p *ngIf="formulaireSoumis && !contenu.trim()" class="mt-1 text-[11.5px] text-red-600">
            Le contenu est obligatoire.
          </p>
        </div>

        <div>
          <div class="mb-1.5 flex items-center justify-between">
            <label class="block text-[12.5px] font-semibold text-slate-700">
              Boutons / liens à insérer
              <span class="font-normal text-slate-400">(optionnel)</span>
            </label>

            <button type="button" (click)="ajouterLien()"
              class="inline-flex items-center gap-1 rounded-md bg-slate-100 px-2.5 py-1 text-[11.5px] font-medium text-slate-700 transition hover:bg-slate-200">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round">
                <path d="M12 5v14M5 12h14" />
              </svg>
              Ajouter un lien
            </button>
          </div>

          <div *ngIf="!liens.length"
            class="rounded-lg border border-dashed border-slate-200 px-3 py-3 text-center text-[12px] text-slate-400">
            Aucun lien ajouté pour l'instant.
          </div>

          <div class="space-y-2">
            <div *ngFor="let l of liens"
              class="flex items-start gap-2 rounded-lg border border-slate-100 bg-slate-50/60 p-2.5">
              <div class="grid min-w-0 flex-1 grid-cols-1 gap-2 sm:grid-cols-2 pt-3 ml-1">
                <div class="min-w-0 w-full">
                  <input type="text" [(ngModel)]="l.label" placeholder="Nom affiché sur le bouton"
                    class="block w-full min-w-0 rounded-md border px-2.5 py-1.5 text-[12.5px] text-slate-800 placeholder:text-slate-400 focus:outline-none"
                    [ngClass]="
            formulaireSoumis && l.url.trim() && !l.label.trim()
              ? 'border-red-300'
              : 'border-slate-200 focus:border-slate-400'
          " />
                </div>

                <div class="min-w-0 w-full">
                  <input type="url" [(ngModel)]="l.url" placeholder="https://…"
                    class="block w-full min-w-0 rounded-md border px-2.5 py-1.5 text-[12.5px] text-slate-800 placeholder:text-slate-400 focus:outline-none"
                    [ngClass]="
            formulaireSoumis && l.label.trim() && !l.url.trim()
              ? 'border-red-300'
              : 'border-slate-200 focus:border-slate-400'
          " />
                </div>
              </div>
              <button type="button" (click)="supprimerLien(l.id)"
                class="mt-2 flex  w-[34px] flex-none items-center justify-center rounded-md text-red-500 transition"
                aria-label="Supprimer ce lien">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
                  stroke-linecap="round">
                  <path d="M3 6h18" />
                  <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                  <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                </svg>
              </button>
            </div>
          </div>

          <p *ngIf="formulaireSoumis && liensInvalides" class="mt-1.5 text-[11.5px] text-red-600">
            Chaque lien doit avoir un nom et une URL, ou être supprimé.
          </p>
        </div>
      </div>
    </div>
    <div *ngIf="!resultatEnvoi && etape === 'edition'"
      class="flex flex-none items-center justify-end gap-2 border-t border-slate-100 px-6 py-4">
      <button type="button" (click)="fermerModal()" [disabled]="envoiEnCours"
        class="rounded-lg px-4 py-2 text-[13px] font-semibold bg-red-600 text-white transition disabled:cursor-not-allowed disabled:opacity-50">
        Annuler
      </button>

      <button type="button" (click)="soumettre()" [disabled]="envoiEnCours"
        class="inline-flex w-[110px] items-center justify-center gap-2 rounded-lg bg-blue-600 px-4 py-2 text-[13px] font-semibold text-white shadow-sm transition hover:bg-blue-700 active:scale-95 disabled:cursor-not-allowed disabled:opacity-60">
        <svg *ngIf="envoiEnCours" class="h-4 w-4 shrink-0 animate-spin" viewBox="0 0 24 24" fill="none">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
        </svg>
        {{ envoiEnCours ? 'Envoi…' : 'Envoyer' }}
      </button>
    </div>

    <div *ngIf="!resultatEnvoi && etape === 'recapitulatif'"
      class="min-w-0 flex-1 overflow-y-auto overflow-x-hidden px-6 py-5">

      <p class="mb-4 rounded-lg bg-amber-50 px-3 py-2 text-[12.5px] text-amber-800">
        Relisez attentivement votre message. Une fois envoyé, il ne pourra plus être modifié.
      </p>

      <div class="space-y-4">
        <div>
          <span class="block text-[11.5px] font-semibold uppercase tracking-wide text-slate-400">
            Destinataires
          </span>
          <p class="mt-1 text-[13px] text-slate-800">
            {{ nombreDestinataires }} apprenant{{ nombreDestinataires > 1 ? 's' : '' }}
          </p>
        </div>

        <div>
          <span class="block text-[11.5px] font-semibold uppercase tracking-wide text-slate-400">
            Objet
          </span>
          <p class="mt-1 break-words text-[13px] font-medium text-slate-800">
            {{ objet }}
          </p>
        </div>

        <div>
          <span class="block text-[11.5px] font-semibold uppercase tracking-wide text-slate-400">
            Contenu
          </span>
          <p
            class="mt-1 whitespace-pre-line break-words rounded-lg border border-slate-100 bg-slate-50 px-3 py-2 text-[13px] text-slate-800">
            {{ contenu }}
          </p>
        </div>

        <div *ngIf="liensValides.length">
          <span class="block text-[11.5px] font-semibold uppercase tracking-wide text-slate-400">
            Boutons / liens
          </span>
          <ul class="mt-1 space-y-1.5">
            <li *ngFor="let l of liensValides"
              class="rounded-lg border border-slate-100 bg-slate-50 px-3 py-2 text-[12.5px]">
              <span class="font-semibold text-slate-800">{{ l.label }}</span>
              <span class="block break-all text-slate-500">{{ l.url }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div *ngIf="!resultatEnvoi && etape === 'recapitulatif'"
      class="flex flex-none items-center justify-end gap-2 border-t border-slate-100 px-6 py-4">
      <button type="button" (click)="modifier()" [disabled]="envoiEnCours"
        class="rounded-lg border border-slate-200 bg-white px-4 py-2 text-[13px] font-semibold text-slate-700 transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-50">
        Modifier
      </button>

      <button type="button" (click)="confirmerEnvoi()" [disabled]="envoiEnCours"
        class="inline-flex min-w-[150px] items-center justify-center gap-2 rounded-lg bg-blue-600 px-4 py-2 text-[13px] font-semibold text-white shadow-sm transition hover:bg-blue-700 active:scale-95 disabled:cursor-not-allowed disabled:opacity-60">
        <svg *ngIf="envoiEnCours" class="h-4 w-4 shrink-0 animate-spin" viewBox="0 0 24 24" fill="none">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
        </svg>
        {{ envoiEnCours ? 'Envoi…' : "Confirmer l'envoi" }}
      </button>
    </div>

    <div *ngIf="resultatEnvoi" class="flex flex-1 flex-col items-center justify-center gap-3 px-6 py-16 text-center">
      <span *ngIf="resultatEnvoi.succes"
        class="flex h-14 w-14 items-center justify-center rounded-full bg-emerald-50 text-emerald-500">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.6" />
          <path d="M8 12l3 3 5-5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </span>

      <span *ngIf="!resultatEnvoi.succes"
        class="flex h-14 w-14 items-center justify-center rounded-full bg-red-50 text-red-500">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.6" />
          <path d="M12 8v5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
          <circle cx="12" cy="16.5" r="1.1" fill="currentColor" />
        </svg>
      </span>

      <p class="max-w-sm text-[14px] font-semibold"
        [ngClass]="resultatEnvoi.succes ? 'text-emerald-700' : 'text-red-700'">
        {{ resultatEnvoi.message }}
      </p>

      <button type="button" (click)="onFermerConfirmation()"
        class="mt-1 rounded-lg bg-slate-800 px-5 py-2 text-[13px] font-semibold text-white transition hover:bg-slate-900">
        OK
      </button>
    </div>
  </div>
</div>